import styled, { css } from 'styled-components';

type BaseProps = {
  isSelected?: boolean;
};

export const Container = styled.div<BaseProps>`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: fit-content;
  padding: 16px 12px;
  border: 0;
  transition: all 0.2s;

  ${({ isSelected }) =>
    isSelected &&
    css`
      border-bottom: 2px solid #0b29fb;
    `}
`;

export const StatusWrap = styled.div``;

export const InfosWrap = styled.div``;

export const BaseName = styled.span<BaseProps>`
  font-family: 'Mangueira';
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: #3d3d3d;

  ${({ isSelected }) =>
    isSelected &&
    css`
      color: #0b29fb;
    `}
`;
